import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";
import { CancelToken } from "axios";

import { DBFilter } from "redux/reducers/filters/filters";

//MEMBERSHIPS
export type TFacilityMembership = {
  add_on?: any;
  client_id: number;
  customer_type_id: number;
  customer_type_title: string;
  expiry: string;
  expiry_type: string;
  id: number;
  membership_type: string;
  product_id: number;
  reciprocal: boolean;
  subtitle: string;
  title: string;
  type: "multi-course" | "single-course";
  variant_id: number;
  archived: boolean;
  logo_image_source: string;
  card_image_source: string;
};
export type TMembershipGet = {
  id?: number;
  /** Search by title and subtitle */
  search?: string;
  filters?: DBFilter[]; // Can be used to filter multiple membership_types
  membership_type?: number;
  privileges?: boolean;
  limit?: number;
  offset?: number;
  archived?: boolean;
};

// GET Membership
export async function GetMembership(params: TMembershipGet, useGlobalLoader: boolean, token?: CancelToken) {
  return await APIGet<TFacilityMembership[]>(
    APIUrl(AdminType.FacilityAdmin, "/membership"),
    params,
    useGlobalLoader,
    token,
  );
}

// PUT Membership
export async function PutMembership(params: any, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/membership"), params, useGlobalLoader);
}

//MEMBERSHIP ADD ON

//GET Membership Add Ons
export async function GetMembershipAddOn(params: any, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/membership/add-on"), params, useGlobalLoader);
}

//PUT Update Memmbership ADd On
export async function PutMembershipAddOn(params: any, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/membership/add-on"), params, useGlobalLoader);
}

//Post Membership Image
export async function UploadMembershipImage(params: any, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.FacilityAdmin, "/membership/image"), params, useGlobalLoader);
}

//Delete Membership Image
export async function RemoveMembershipImage(params: { id: number; type: "logo" | "card" }, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.FacilityAdmin, "/membership/image"), params, useGlobalLoader);
}

export async function PutMembershipArchive(params: {id: number}, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.FacilityAdmin, "/membership/archive"), params, useGlobalLoader);
}
